"use client";

import { useEffect, useState } from "react";
import type { ActiveTetrisEvent } from "@/utils/tetris-api";

export function useEventCountdown(event?: ActiveTetrisEvent | null) {
  const [seconds, setSeconds] = useState<number | null>(event?.timeRemainingSeconds ?? null);

  useEffect(() => {
    if (!event?.timeRemainingSeconds) {
      setSeconds(null);
      return;
    }

    setSeconds(event.timeRemainingSeconds);
    const intervalId = window.setInterval(() => {
      setSeconds((prev) => {
        if (prev === null) return null;
        return prev > 0 ? prev - 1 : 0;
      });
    }, 1000);

    return () => window.clearInterval(intervalId);
  }, [event?.slug, event?.timeRemainingSeconds]);

  return seconds;
}
